export const countryOptions = [
  {
    key: "Afghanistan",
    label: "Afghanistan",
  },
  {
    key: "Albania",
    label: "Albania",
  },
  {
    key: "Algeria",
    label: "Algeria",
  },
  {
    key: "American Samoa",
    label: "American Samoa",
  },
  {
    key: "Andorra",
    label: "Andorra",
  },
  {
    key: "Angola",
    label: "Angola",
  },
  {
    key: "Anguilla",
    label: "Anguilla",
  },
  {
    key: "Antarctica",
    label: "Antarctica",
  },
  {
    key: "Antigua and Barbuda",
    label: "Antigua and Barbuda",
  },
  {
    key: "Argentina",
    label: "Argentina",
  },
  {
    key: "Armenia",
    label: "Armenia",
  },
  {
    key: "Artsakh",
    label: "Artsakh",
  },
  {
    key: "Aruba",
    label: "Aruba",
  },
  {
    key: "Australia",
    label: "Australia",
  },
  {
    key: "Austria",
    label: "Austria",
  },
  {
    key: "Bahamas",
    label: "Bahamas",
  },
  {
    key: "Bahrain",
    label: "Bahrain",
  },
  {
    key: "Bangladesh",
    label: "Bangladesh",
  },
  {
    key: "Barbados",
    label: "Barbados",
  },
  {
    key: "Belarus",
    label: "Belarus",
  },
  {
    key: "Belgium",
    label: "Belgium",
  },
  {
    key: "Belize",
    label: "Belize",
  },
  {
    key: "Benin",
    label: "Benin",
  },
  {
    key: "Bermuda",
    label: "Bermuda",
  },
  {
    key: "Bhutan",
    label: "Bhutan",
  },
  {
    key: "Bolivia",
    label: "Bolivia",
  },
  {
    key: "Bonaire, Sint Eustatius and Saba",
    label: "Bonaire, Sint Eustatius and Saba",
  },
  {
    key: "Bosnia and Herzegovina",
    label: "Bosnia and Herzegovina",
  },
  {
    key: "Botswana",
    label: "Botswana",
  },
  {
    key: "Bouvet Island",
    label: "Bouvet Island",
  },
  {
    key: "Brazil",
    label: "Brazil",
  },
  {
    key: "British Indian Ocean Territory",
    label: "British Indian Ocean Territory",
  },
  {
    key: "Brunei Darussalam",
    label: "Brunei Darussalam",
  },
  {
    key: "Bulgaria",
    label: "Bulgaria",
  },
  {
    key: "Burkina Faso",
    label: "Burkina Faso",
  },
  {
    key: "Burundi",
    label: "Burundi",
  },
  {
    key: "Cabo Verde",
    label: "Cabo Verde",
  },
  {
    key: "Cambodia",
    label: "Cambodia",
  },
  {
    key: "Cameroon",
    label: "Cameroon",
  },
  {
    key: "Canada",
    label: "Canada",
  },
  {
    key: "Cayman Islands",
    label: "Cayman Islands",
  },
  {
    key: "Central African Republic",
    label: "Central African Republic",
  },
  {
    key: "Chad",
    label: "Chad",
  },
  {
    key: "Chile",
    label: "Chile",
  },
  {
    key: "China",
    label: "China",
  },
  {
    key: "Christmas Island",
    label: "Christmas Island",
  },
  {
    key: "Cocos Islands",
    label: "Cocos Islands",
  },
  {
    key: "Colombia",
    label: "Colombia",
  },
  {
    key: "Comoros",
    label: "Comoros",
  },
  {
    key: "Congo",
    label: "Congo",
  },
  {
    key: "Cook Islands",
    label: "Cook Islands",
  },
  {
    key: "Costa Rica",
    label: "Costa Rica",
  },
  {
    key: "Croatia",
    label: "Croatia",
  },
  {
    key: "Cuba",
    label: "Cuba",
  },
  {
    key: "Curaçao",
    label: "Curaçao",
  },
  {
    key: "Cyprus",
    label: "Cyprus",
  },
  {
    key: "Czechia",
    label: "Czechia",
  },
  {
    key: "Côte d'Ivoire",
    label: "Côte d'Ivoire",
  },
  {
    key: "Denmark",
    label: "Denmark",
  },
  {
    key: "Djibouti",
    label: "Djibouti",
  },
  {
    key: "Dominica",
    label: "Dominica",
  },
  {
    key: "Dominican Republic",
    label: "Dominican Republic",
  },
  {
    key: "Ecuador",
    label: "Ecuador",
  },
  {
    key: "Egypt",
    label: "Egypt",
  },
  {
    key: "El Salvador",
    label: "El Salvador",
  },
  {
    key: "Equatorial Guinea",
    label: "Equatorial Guinea",
  },
  {
    key: "Eritrea",
    label: "Eritrea",
  },
  {
    key: "Estonia",
    label: "Estonia",
  },
  {
    key: "Eswatini",
    label: "Eswatini",
  },
  {
    key: "Ethiopia",
    label: "Ethiopia",
  },
  {
    key: "Falkland Islands [Malvinas]",
    label: "Falkland Islands [Malvinas]",
  },
  {
    key: "Faroe Islands",
    label: "Faroe Islands",
  },
  {
    key: "Fiji",
    label: "Fiji",
  },
  {
    key: "Finland",
    label: "Finland",
  },
  {
    key: "France",
    label: "France",
  },
  {
    key: "French Guiana",
    label: "French Guiana",
  },
  {
    key: "French Polynesia",
    label: "French Polynesia",
  },
  {
    key: "French Southern Territories",
    label: "French Southern Territories",
  },
  {
    key: "Gabon",
    label: "Gabon",
  },
  {
    key: "Gambia",
    label: "Gambia",
  },
  {
    key: "Georgia",
    label: "Georgia",
  },
  {
    key: "Germany",
    label: "Germany",
  },
  {
    key: "Ghana",
    label: "Ghana",
  },
  {
    key: "Gibraltar",
    label: "Gibraltar",
  },
  {
    key: "Greece",
    label: "Greece",
  },
  {
    key: "Greenland",
    label: "Greenland",
  },
  {
    key: "Grenada",
    label: "Grenada",
  },
  {
    key: "Guadeloupe",
    label: "Guadeloupe",
  },
  {
    key: "Guam",
    label: "Guam",
  },
  {
    key: "Guatemala",
    label: "Guatemala",
  },
  {
    key: "Guernsey",
    label: "Guernsey",
  },
  {
    key: "Guinea",
    label: "Guinea",
  },
  {
    key: "Guinea-Bissau",
    label: "Guinea-Bissau",
  },
  {
    key: "Guyana",
    label: "Guyana",
  },
  {
    key: "Haiti",
    label: "Haiti",
  },
  {
    key: "Heard Island and McDonald Islands",
    label: "Heard Island and McDonald Islands",
  },
  {
    key: "Holy See",
    label: "Holy See",
  },
  {
    key: "Honduras",
    label: "Honduras",
  },
  {
    key: "Hong Kong",
    label: "Hong Kong",
  },
  {
    key: "Hungary",
    label: "Hungary",
  },
  {
    key: "Iceland",
    label: "Iceland",
  },
  {
    key: "India",
    label: "India",
  },
  {
    key: "Indonesia",
    label: "Indonesia",
  },
  {
    key: "Iran",
    label: "Iran",
  },
  {
    key: "Iraq",
    label: "Iraq",
  },
  {
    key: "Ireland",
    label: "Ireland",
  },
  {
    key: "Isle of Man",
    label: "Isle of Man",
  },
  {
    key: "Israel",
    label: "Israel",
  },
  {
    key: "Italy",
    label: "Italy",
  },
  {
    key: "Jamaica",
    label: "Jamaica",
  },
  {
    key: "Japan",
    label: "Japan",
  },
  {
    key: "Jersey",
    label: "Jersey",
  },
  {
    key: "Jordan",
    label: "Jordan",
  },
  {
    key: "Kazakhstan",
    label: "Kazakhstan",
  },
  {
    key: "Kenya",
    label: "Kenya",
  },
  {
    key: "Kiribati",
    label: "Kiribati",
  },
  {
    key: "Korea",
    label: "Korea",
  },
  {
    key: "Kuwait",
    label: "Kuwait",
  },
  {
    key: "Kyrgyzstan",
    label: "Kyrgyzstan",
  },
  {
    key: "Lao People's Democratic Republic",
    label: "Lao People's Democratic Republic",
  },
  {
    key: "Latvia",
    label: "Latvia",
  },
  {
    key: "Lebanon",
    label: "Lebanon",
  },
  {
    key: "Lesotho",
    label: "Lesotho",
  },
  {
    key: "Liberia",
    label: "Liberia",
  },
  {
    key: "Libya",
    label: "Libya",
  },
  {
    key: "Liechtenstein",
    label: "Liechtenstein",
  },
  {
    key: "Lithuania",
    label: "Lithuania",
  },
  {
    key: "Luxembourg",
    label: "Luxembourg",
  },
  {
    key: "Macao",
    label: "Macao",
  },
  {
    key: "Madagascar",
    label: "Madagascar",
  },
  {
    key: "Malawi",
    label: "Malawi",
  },
  {
    key: "Malaysia",
    label: "Malaysia",
  },
  {
    key: "Maldives",
    label: "Maldives",
  },
  {
    key: "Mali",
    label: "Mali",
  },
  {
    key: "Malta",
    label: "Malta",
  },
  {
    key: "Marshall Islands",
    label: "Marshall Islands",
  },
  {
    key: "Martinique",
    label: "Martinique",
  },
  {
    key: "Mauritania",
    label: "Mauritania",
  },
  {
    key: "Mauritius",
    label: "Mauritius",
  },
  {
    key: "Mayotte",
    label: "Mayotte",
  },
  {
    key: "Mexico",
    label: "Mexico",
  },
  {
    key: "Micronesia",
    label: "Micronesia",
  },
  {
    key: "Moldova",
    label: "Moldova",
  },
  {
    key: "Monaco",
    label: "Monaco",
  },
  {
    key: "Mongolia",
    label: "Mongolia",
  },
  {
    key: "Montenegro",
    label: "Montenegro",
  },
  {
    key: "Montserrat",
    label: "Montserrat",
  },
  {
    key: "Morocco",
    label: "Morocco",
  },
  {
    key: "Mozambique",
    label: "Mozambique",
  },
  {
    key: "Myanmar",
    label: "Myanmar",
  },
  {
    key: "Namibia",
    label: "Namibia",
  },
  {
    key: "Nauru",
    label: "Nauru",
  },
  {
    key: "Nepal",
    label: "Nepal",
  },
  {
    key: "Netherlands",
    label: "Netherlands",
  },
  {
    key: "New Caledonia",
    label: "New Caledonia",
  },
  {
    key: "New Zealand",
    label: "New Zealand",
  },
  {
    key: "Nicaragua",
    label: "Nicaragua",
  },
  {
    key: "Niger",
    label: "Niger",
  },
  {
    key: "Nigeria",
    label: "Nigeria",
  },
  {
    key: "Niue",
    label: "Niue",
  },
  {
    key: "Norfolk Island",
    label: "Norfolk Island",
  },
  {
    key: "Northern Mariana Islands",
    label: "Northern Mariana Islands",
  },
  {
    key: "Norway",
    label: "Norway",
  },
  {
    key: "Oman",
    label: "Oman",
  },
  {
    key: "Pakistan",
    label: "Pakistan",
  },
  {
    key: "Palau",
    label: "Palau",
  },
  {
    key: "Palestine, State of",
    label: "Palestine, State of",
  },
  {
    key: "Panama",
    label: "Panama",
  },
  {
    key: "Papua New Guinea",
    label: "Papua New Guinea",
  },
  {
    key: "Paraguay",
    label: "Paraguay",
  },
  {
    key: "Peru",
    label: "Peru",
  },
  {
    key: "Philippines",
    label: "Philippines",
  },
  {
    key: "Pitcairn",
    label: "Pitcairn",
  },
  {
    key: "Poland",
    label: "Poland",
  },
  {
    key: "Portugal",
    label: "Portugal",
  },
  {
    key: "Puerto Rico",
    label: "Puerto Rico",
  },
  {
    key: "Qatar",
    label: "Qatar",
  },
  {
    key: "Republic of North Macedonia",
    label: "Republic of North Macedonia",
  },
  {
    key: "Romania",
    label: "Romania",
  },
  {
    key: "Russian",
    label: "Russian",
  },
  {
    key: "Rwanda",
    label: "Rwanda",
  },
  {
    key: "Réunion",
    label: "Réunion",
  },
  {
    key: "Saint Barthélemy",
    label: "Saint Barthélemy",
  },
  {
    key: "Saint Helena, Ascension and Tristan da Cunha",
    label: "Saint Helena, Ascension and Tristan da Cunha",
  },
  {
    key: "Saint Kitts and Nevis",
    label: "Saint Kitts and Nevis",
  },
  {
    key: "Saint Lucia",
    label: "Saint Lucia",
  },
  {
    key: "Saint Martin",
    label: "Saint Martin",
  },
  {
    key: "Saint Pierre and Miquelon",
    label: "Saint Pierre and Miquelon",
  },
  {
    key: "Saint Vincent and the Grenadines",
    label: "Saint Vincent and the Grenadines",
  },
  {
    key: "Samoa",
    label: "Samoa",
  },
  {
    key: "San Marino",
    label: "San Marino",
  },
  {
    key: "Sao Tome and Principe",
    label: "Sao Tome and Principe",
  },
  {
    key: "Saudi Arabia",
    label: "Saudi Arabia",
  },
  {
    key: "Senegal",
    label: "Senegal",
  },
  {
    key: "Serbia",
    label: "Serbia",
  },
  {
    key: "Seychelles",
    label: "Seychelles",
  },
  {
    key: "Sierra Leone",
    label: "Sierra Leone",
  },
  {
    key: "Singapore",
    label: "Singapore",
  },
  {
    key: "Sint Maarten",
    label: "Sint Maarten",
  },
  {
    key: "Slovakia",
    label: "Slovakia",
  },
  {
    key: "Slovenia",
    label: "Slovenia",
  },
  {
    key: "Solomon Islands",
    label: "Solomon Islands",
  },
  {
    key: "Somalia",
    label: "Somalia",
  },
  {
    key: "South Africa",
    label: "South Africa",
  },
  {
    key: "South Georgia and the South Sandwich Islands",
    label: "South Georgia and the South Sandwich Islands",
  },
  {
    key: "South Sudan",
    label: "South Sudan",
  },
  {
    key: "Spain",
    label: "Spain",
  },
  {
    key: "Sri Lanka",
    label: "Sri Lanka",
  },
  {
    key: "Sudan",
    label: "Sudan",
  },
  {
    key: "Suriname",
    label: "Suriname",
  },
  {
    key: "Svalbard and Jan Mayen",
    label: "Svalbard and Jan Mayen",
  },
  {
    key: "Sweden",
    label: "Sweden",
  },
  {
    key: "Switzerland",
    label: "Switzerland",
  },
  {
    key: "Syrian Arab Republic",
    label: "Syrian Arab Republic",
  },
  {
    key: "Taiwan",
    label: "Taiwan",
  },
  {
    key: "Tajikistan",
    label: "Tajikistan",
  },
  {
    key: "Tanzania, United Republic of",
    label: "Tanzania, United Republic of",
  },
  {
    key: "Thailand",
    label: "Thailand",
  },
  {
    key: "Timor-Leste",
    label: "Timor-Leste",
  },
  {
    key: "Togo",
    label: "Togo",
  },
  {
    key: "Tokelau",
    label: "Tokelau",
  },
  {
    key: "Tonga",
    label: "Tonga",
  },
  {
    key: "Trinidad and Tobago",
    label: "Trinidad and Tobago",
  },
  {
    key: "Tunisia",
    label: "Tunisia",
  },
  {
    key: "Turkey",
    label: "Turkey",
  },
  {
    key: "Turkmenistan",
    label: "Turkmenistan",
  },
  {
    key: "Turks and Caicos Islands",
    label: "Turks and Caicos Islands",
  },
  {
    key: "Tuvalu",
    label: "Tuvalu",
  },
  {
    key: "Uganda",
    label: "Uganda",
  },
  {
    key: "Ukraine",
    label: "Ukraine",
  },
  {
    key: "United Arab Emirates",
    label: "United Arab Emirates",
  },
  {
    key: "United Kingdom of Great Britain and Northern Ireland",
    label: "United Kingdom of Great Britain and Northern Ireland",
  },
  {
    key: "United States Minor Outlying Islands",
    label: "United States Minor Outlying Islands",
  },
  {
    key: "USA",
    label: "USA",
  },
  {
    key: "Uruguay",
    label: "Uruguay",
  },
  {
    key: "Uzbekistan",
    label: "Uzbekistan",
  },
  {
    key: "Vanuatu",
    label: "Vanuatu",
  },
  {
    key: "Venezuela",
    label: "Venezuela",
  },
  {
    key: "Viet Nam",
    label: "Viet Nam",
  },
  {
    key: "Virgin Islands",
    label: "Virgin Islands",
  },
  {
    key: "Wallis and Futuna",
    label: "Wallis and Futuna",
  },
  {
    key: "Western Sahara",
    label: "Western Sahara",
  },
  {
    key: "Yemen",
    label: "Yemen",
  },
  {
    key: "Zambia",
    label: "Zambia",
  },
  {
    key: "Zimbabwe",
    label: "Zimbabwe",
  },
  {
    key: "Åland Islands",
    label: "Åland Islands",
  },
];

export const monthOptions = [
  { key: "January", label: "January" },
  { key: "February", label: "February" },
  { key: "March", label: "March" },
  { key: "April", label: "April" },
  { key: "May", label: "May" },
  { key: "June", label: "June" },
  { key: "July", label: "July" },
  { key: "August", label: "August" },
  { key: "September", label: "September" },
  { key: "October", label: "October" },
  { key: "November", label: "November" },
  { key: "December", label: "December" },
];

export const dayOptions = Array.from({ length: 31 }, (_, i) => ({
  key: i + 1,
  label: String(i + 1),
}));

const currentYear = new Date().getFullYear();
export const yearOptions = Array.from({ length: 70 - 16 + 1 }, (_, i) => ({
  key: currentYear - (16 + i),
  label: String(currentYear - (16 + i)),
}));
